import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, Avatar } from "@mui/material";
import ApiService from "./../../services/api-service";
import LockIcon from "@mui/icons-material/Lock";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Loader from "./../../components/Loader";
import NoData from "./../../components/Nodata";
import Back from "../../components/Back";
import { Images } from "../../assets/common";
import { useDispatch } from "react-redux";
import { addSongAction } from "./../../action/songs";
import {
  fullName,
  getUserId,
  HMS,
  isOwnerId,
} from "./../../constants/function";
import { useParams, useHistory } from "react-router-dom";

import PlaylistStaticsCard from "../../components/PlaylistStaticsCard";
import ProfileMenu from "../../components/ProfileMenu";
import OutsideClickHandler from "react-outside-click-handler";
import notifier from "../../components/Notifier";
import { useTranslation } from "react-i18next";
import "./index.scss";

export default function PlaylistStatics() {
  const { t } = useTranslation("common");
  const history = useHistory();
  const userId = getUserId();
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const { playListId, createdBy } = useParams();
  const [loading, setLoading] = useState();
  const [data, setData] = useState({});
  useEffect(() => {
    if (playListId && createdBy) getPlaylistStatics(playListId, createdBy);
  }, []);

  /**
   * @param  {} playListId
   * @param  {} createdBy
   */
  const getPlaylistStatics = async (playListId, createdBy) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_STATICS({
        playlistid: playListId,
        playlistcreator: createdBy,
        _id: userId,
      });
      setData({ ...response["result"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const toggleMenu = (value, id, index) => {
    setOpen(false);
    setSelectedIndex(index);

    if (value && id) makeAction(value, id, index);
    else if (value) makeAction(value);
  };

  const makeAction = (key, id, index) => {
    switch (key) {
      case "m1":
        data["topStreamed"][index]?.nftId
          ? history.push(`/app/SongDetails/${data["topStreamed"][index]?.nftId}?nft=true`)
          : history.push(`/app/SongDetails/${id}`);
        break;
      case "m24":
        removeSongFromPlaylist(index, data["topStreamed"][index], id);
        break;

      case "m2":
        if (!isOwnerId(createdBy) && !data["isSubscribed"] && data["isPrivate"])
          notifier.error(t("notifier.error.toast5"));
        else
          dispatch(addSongAction(data["topStreamed"][index], playListId, true));
        break;
      default:
        break;
    }
  };
  const play = (index) => {
    if (!isOwnerId(createdBy) && !data["isSubscribed"] && data["isPrivate"])
      notifier.error(t("notifier.error.toast5"));
    else dispatch(addSongAction(data["topStreamed"][index], playListId, true));
  };

  const removeSongFromPlaylist = async (index, song, id) => {
    try {
      setLoading(true);
      const response = await ApiService.REMOVE_SONG_FROM_PLAYLIST({
        musicId: song["_id"],
        playlistId: playListId,
      });
      setData({ ...data, topStreamed: data["topStreamed"].filter((_, i) => i !== index) });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Box>
      <Back />
      <Box className="gs-page">
        <div className="gs-page-header">
          <Typography className="gs-page-title">
            <span>{"// "}</span>{t("playlistStatics.title")}
          </Typography>
        </div>

        {/* Hero Stat */}
        <div className="gs-hero-section">
          <PlaylistStaticsCard
            statType="listens"
            value={data["listens"]}
            title={t("analytics.card.card3")}
            image={Images.listen}
          />
        </div>

        {/* Achievement Badges */}
        <div className="gs-badges-row">
          <PlaylistStaticsCard
            statType="firstListens"
            value={data["firstTimeListensCount"]}
            title={t("playlistStatics.header3")}
            image={Images.play_white}
          />
          <PlaylistStaticsCard
            statType="firstListings"
            value={data["firstTimeListings"]}
            title={t("playlistStatics.header4")}
            image={Images.listen_first}
          />
          <PlaylistStaticsCard
            statType="topPlaylist"
            value={data["topPlaylistCount"]}
            title={t("playlistStatics.header5")}
            image={Images.top_playlist}
          />
        </div>

        {/* Social Leaderboards */}
        <div className="gs-social-row">
          <PlaylistStaticsCard
            statType="topListeners"
            isArray={true}
            value={
              data["topTenListeners"]
                ? data["topTenListeners"].length > 10
                  ? data["topTenListeners"].slice(0, 9)
                  : data["topTenListeners"]
                : []
            }
            title={t("playlistStatics.header6")}
            image={Images.music_play}
          />
          <PlaylistStaticsCard
            statType="topTippers"
            isTip={true}
            value={data["topTenTips"]}
            title={"Top 10 Tippers"}
            image={Images.handHolding}
          />
        </div>

        {/* Top Streamed Tracks */}
        <Box className="gs-tracks-section" sx={{ padding: "0 0 160px 0", position: "relative" }}>
          <Typography className="gs-tracks-label">
            {t("playlistStatics.title2")}
          </Typography>

          {data["topStreamed"] && data["topStreamed"].length > 0 ? (
            <table className="mymusic_table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("playlistStatics.th1")}</th>
                  <th>{t("playlistStatics.th2")}</th>
                  <th>{t("playlistStatics.th3")}</th>
                </tr>
              </thead>
              <tbody>
                {data["topStreamed"] &&
                  data["topStreamed"].map((music, index) => (
                    <tr key={index} style={{ position: "relative" }}>
                      <td>
                        <span className={`gs-rank ${index < 3 ? 'gs-rank--gold' : ''}`}>
                          {index + 1}
                        </span>
                      </td>
                      <td>
                        <Stack direction="row" spacing={2}>
                          <Stack className="__music_thumb _cp">
                            <Avatar
                              src={
                                music["thumbnailImg"]["filePath"]
                                  ? music["thumbnailImg"]["filePath"]
                                  : Images.rectangle
                              }
                            />
                            <img
                              onClick={() => play(index)}
                              className="__play_hover"
                              src={Images.play}
                              alt="play"
                            />
                          </Stack>
                          <Stack direction="column" justifyContent="center">
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Typography
                                variant="body1"
                                className="fs-16 capitalize"
                              >
                                {music["title"] ? music["title"] : ""}
                              </Typography>
                              {music["private"] ? (
                                <LockIcon
                                  sx={{
                                    width: "11px",
                                    height: "11px",
                                    padding: "2px",
                                    color: "#989898",
                                    backgroundColor: "#4E4E4E",
                                  }}
                                  className="__small_icon"
                                />
                              ) : null}
                            </Stack>
                            <Stack
                              direction="row"
                              alignItems="center"
                              sx={{
                                overflowX: "scroll",
                                gap: "6px",
                                width: "245px",
                              }}
                              className="scroll_display_musicCard"
                            >
                              {music.artistData ? (
                                music.artistData.map((a, index) => (
                                  <Typography
                                    className="fs-14 fade-text-60"
                                    key={index}
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    {a?.displayArtistName}
                                    {index == music.artistData.length - 1
                                      ? ""
                                      : ","}
                                  </Typography>
                                ))
                              ) : (
                                <Typography
                                  variant="body2"
                                  className="fs-14 fade-text"
                                >
                                  {music["artist"] ? music["artist"] : ""}
                                </Typography>
                              )}
                            </Stack>
                          </Stack>
                        </Stack>
                      </td>
                      <td className="text-center text-white fs-14">
                        {HMS(music["duration"])}
                      </td>
                      <td className="text-right">
                        <MoreVertIcon
                          className="_cp"
                          onClick={() => {
                            setSelectedIndex(index);
                            setOpen(!open);
                          }}
                          color="default"
                        />
                      </td>
                      {index === selectedIndex && open ? (
                        <OutsideClickHandler
                          onOutsideClick={() => setOpen(false)}
                        >
                          <ProfileMenu
                            right={"0px"}
                            isLast={
                              index === music.length - 1 ? "-90px" : "40px"
                            }
                            isMenu={open}
                            actions={[
                              { key: "m1", action: t("dropMenu.m1") },
                              { key: "m2", action: t("dropMenu.m2") },
                              isOwnerId(createdBy)
                                ? {
                                    key: "m24",
                                    action: t("dropMenu.m24"),
                                  }
                                : "",
                            ]}
                            handleProfileMenuChoice={(action) =>
                              toggleMenu(action, music._id, index)
                            }
                          />
                        </OutsideClickHandler>
                      ) : null}
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <NoData lable={t("noData.noData")} />
          )}
        </Box>

        {loading ? <Loader /> : null}
      </Box>
    </Box>
  );
}
